import React, { useState } from 'react';
import Carousel, { CarouselSlide } from '../../Carousel';
import Link from 'next/link';
import _ from 'lodash';
import useWindowSize from 'flaivy-react/hooks/UseWindowSize';

const Block = ({ item, windowSize }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      className="block-carousel-item"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        boxShadow: item.useDarkenEffect
          ? `inset 5000px 5000px rgba(0, 0, 0, 0.2)`
          : '',
        backgroundImage: `url('${
          hover && item.useHoverEffect ? item.hoverImage : item.image
        }')`,
        backgroundColor:
          hover && item.useHoverEffect
            ? item.hoverBackgroundColor
            : item.backgroundColor,
      }}
    >
      <Link
        href={item.link}
        className={`text-center block-carousel-link  ${
          _.includes(['sm', 'xs'], windowSize.bootstrapSize)
            ? 'd-flex justify-content-center'
            : ''
        }`}
        style={{
          color: item.textColor,
        }}
      >
        <h2>{item.title}</h2>
      </Link>
    </div>
  );
};

function ImageCarouselComponent({ blockCarousel, isFluid }) {
  const windowSize = useWindowSize();

  return (
    <div className={isFluid ? 'px-2' : ''}>
      <Carousel
        key={blockCarousel.id}
        id={blockCarousel.id}
        minHeight="0px"
        spaceBetween={10}
        fullFlex={true}
      >
        {blockCarousel.blocks.map(item => (
          <CarouselSlide
            key={item.id}
            className={'block-carousel-item-container'}
            style={{ flex: '1 0 auto' }}
          >
            <Block item={item} windowSize={windowSize} />
          </CarouselSlide>
        ))}
      </Carousel>
    </div>
  );
}

export default ImageCarouselComponent;
